module.exports = __webpack_public_path__ + "static/img/piao1.51ac52f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/piao1.png
// module id = rX19
// module chunks = 1